import { ButtonDS, Spacer, TextCapitalized, triggerToastDS } from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import styled from "styled-components";
import { ElectricCharge } from "../electricChargingAPI";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  electricChargingSlice,
  reimburseChargesAsync,
  selectReimburseChargesStatus,
} from "../electricChargingSlice";
import "../../../../i18n/i18n";

export const SidePanelReimburse = (props: {
  charge: ElectricCharge;
  refundAmount: number;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { charge, refundAmount } = props;
  const reimburseStatus = useAppSelector(selectReimburseChargesStatus);

  useEffect(() => {
    if (reimburseStatus === "success") {
      triggerToastDS(
        t("electric_charging.sidePanel.reimburse.success", {
          amount: refundAmount.toFixed(2),
        }),
        "SUCCESS",
      );
      dispatch(electricChargingSlice.actions.resetReimburseChargesStatus());
    }
    if (reimburseStatus === "failed") {
      triggerToastDS(t("electric_charging.sidePanel.reimburse.error"), "ERROR");
      dispatch(electricChargingSlice.actions.resetReimburseChargesStatus());
    }
  }, [reimburseStatus, t, dispatch, refundAmount]);

  return (
    <StyledContainer>
      <StyledRow>
        <TextCapitalized>
          {t("electric_charging.sidePanel.refundAmount")}
        </TextCapitalized>
        <StyledAmount>{refundAmount.toFixed(2)}&nbsp;€</StyledAmount>
      </StyledRow>
      <Spacer y={1} />
      <ButtonDS
        text={t("electric_charging.sidePanel.reimburse.button")}
        format="fill"
        buttonType="primary"
        onClick={() => void dispatch(reimburseChargesAsync([charge.uuid]))}
        disabled={reimburseStatus === "processing"}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${typographies["Body/M"]};
`;

const StyledAmount = styled.div`
  font-weight: 700;
`;
